import { Input } from "../ui";

/* eslint-disable no-unused-vars */
export const TextField = ({ formField, currentPosition, ...props }) => <Input { ...props } type="text" />;